import * as Services from "../models/swagger/generated-submission-service";
import { fileService } from "./file.service";

export const FileService = {
    upload: fileService.upload,
    uploadError: fileService.uploadError,
    get: fileService.get,
    list: Services.FileUploadService.list,
    delete: Services.FileUploadService.delete,
    previewLink: Services.FileUploadService.previewlink,
    previewList: Services.FileUploadService.previewlist,
};

export const SubmissionService = {
    submit: Services.QueueService.submit,
    serve: Services.QueueService.serve,
    submitDFS: Services.QueueService.dfs,
    checkSimilar: Services.QueueService.checkSimilar,
    cancel: Services.QueueService.cancel,
    cancelHold: Services.QueueService.cancelHold,
    cancelAll: Services.QueueService.cancelAll,
    fail: Services.QueueService.fail,
    hold: Services.QueueService.hold,
    viewDocument: Services.DocumentsService.view,
    uploadExisting: Services.EFileService.existing,
    uploadNewCase: Services.EFileService.newCase,
    uploadBatch: Services.EFileService.batch,
    uploadOrder: Services.EFileService.order,
    uploadService: Services.EFileService.service,
    get: Services.SubmissionDetailService.submissionDetail2,
    autofile: Services.QueueService.attorney3,
    sync: Services.QueueService.sync,
    syncByAttorney: Services.QueueService.attorney1,
    aiPopulate: Services.QueueService.aipopulate,
    aiPopulateByAttorney: Services.QueueService.attorney2,
    update: Services.SubmissionDetailService.submissionUpdate,
    search: Services.SubmissionDetailService.searchSubmissions,
    getDocumentsByUcn: Services.DocumentsService.getByUcn,
    efilemycases: Services.EFileService.efilemycases,
    submissionByFileId: Services.QueueService.fileId,
    previewExisting: Services.EFileService.previewexisting,
    previewNewcase: Services.EFileService.previewNewcase,
    cancelAutoFile: Services.QueueService.cancelAutoFile,
    checkDoubleFile: Services.SubmissionService.doubleFile,
    // Opt-In submits the current submission against a cached case search.
    optIn: Services.QueueService.submitFromCache,
};

export const QueueService = {
    getQueue: Services.QueueService.queue,
    getQueueByAttorney: Services.QueueService.byAttorney,
    getQueueCount: Services.QueueService.count,
    get: Services.QueueService.submission,
    next: Services.QueueService.next,
    hide: Services.QueueService.hide,
    reloadCase: Services.QueueService.submission1,
    deleteEfmeSubmit: Services.QueueService.deleteEfmeSubmit,
};

export const ReportService = {
    getSubmissionsToday: Services.ReportingService.today,
    getUploadsToday: Services.UploadsService.today,
    getExistingToday: Services.ReportingService.existing,
    getNewToday: Services.ReportingService.new,
    getDfsToday: Services.ReportingService.dfs,
    getMonthly: Services.ReportingService.monthly,
    getByState: Services.ReportingService.portalIdentifier,
    getLast90days: Services.ReportingService.last90Days,
    getEFileReporting: Services.ReportingService.efilereport,
    search: Services.ReportingService.search,
    filingStatus: Services.ReportingService.status,
    getRecentReporting: Services.ReportingService.recent,
};

export const DocumentService = {
    getPageText: Services.DocumentsService.page,
    split: Services.DocumentsService.split,
    getSplit: Services.DocumentsService.split1,
};

export const eFileService = {
    begin: Services.EFileService.begin,
    get: Services.EFileService.eFile,
};

export const EmailService = {
    add: Services.EmailService.email,
    update: Services.EmailService.email1,
    delete: Services.EmailService.email2,
    getAll: Services.EmailService.emails,
};

export const PartyService = {
    add: Services.PartyService.party,
    update: Services.PartyService.party1,
    delete: Services.PartyService.party2,
    getAll: Services.PartyService.parties,
    leadAttorney: Services.PartyService.leadAttorney,
};

export const CaseDataService = {
    update: Services.CaseDataDetailService.submission,
    find_original_new_suit: Services.CaseDataDetailService.originalNewSuit,
};

export const EmailReciptService = {
    add: Services.EmailRecieptService.emailReciept1,
    getList: Services.EmailRecieptService.submission,
    sendReceipts: Services.EmailRecieptService.resend,
};

export const CoversheetService = {
    add: Services.CoversheetService.addcoversheet,
    getList: Services.CoversheetService.listcoversheet,
};

export const TylerEnvelopeService = {
    fileIntoExisting: Services.EnvelopeService.existingCase,
    initiateNewSuit: Services.EnvelopeService.newCase,
    write: Services.EnvelopeService.write,
    access: Services.EnvelopeService.read,
    submit: Services.TylerSubmissionService.tylerSubmission,
};
export const TylerFeeService = {
    new: Services.FeeCalculatorService.new,
    existing: Services.FeeCalculatorService.existing,
};

export const SystemSettingsService = {
    get: Services.SystemSettingsService.systemSettings,
    refresh: Services.SystemSettingsService.refresh,
    update: Services.SystemSettingsService.update,
    clear: Services.SystemSettingsService.clear,
};

export const AutofileService = {
    getMaster: Services.AutoFileService.autoFile,
    getDetails: Services.AutoFileService.detail,
};

export const PendingServiceService = {
    getList: Services.PendingServiceDocumentService.list,
    notify: Services.PendingServiceDocumentService.notify,
    ignore: Services.PendingServiceDocumentService.ignore,
};
